<template>
  <PageFAQ :title="block.title" :questions="block.questions"></PageFAQ>
</template>

<script>
import PageFAQ from '@saas/components/page/PageFAQ'

export default {
  name: 'PageBlockFAQ',
  components: { PageFAQ },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
}
</script>
